import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { showToast, ToastSeverity } from '../store/toastSlice';

interface ToastMethods {
  showSuccess: (message: string) => void;
  showError: (message: string) => void;
  showWarning: (message: string) => void;
  showInfo: (message: string) => void;
  show: (message: string, severity: ToastSeverity) => void;
}

export const useToast = (): ToastMethods => {
  const dispatch = useDispatch();

  const showSuccess = useCallback((message: string) => {
    dispatch(showToast({ message, severity: 'success' }));
  }, [dispatch]);

  const showError = useCallback((message: string) => {
    dispatch(showToast({ message, severity: 'error' }));
  }, [dispatch]);

  const showWarning = useCallback((message: string) => {
    dispatch(showToast({ message, severity: 'warning' }));
  }, [dispatch]);

  const showInfo = useCallback((message: string) => {
    dispatch(showToast({ message, severity: 'info' }));
  }, [dispatch]);

  const show = useCallback((message: string, severity: ToastSeverity) => {
    dispatch(showToast({ message, severity }));
  }, [dispatch]);

  return {
    showSuccess,
    showError,
    showWarning,
    showInfo,
    show,
  };
};

